export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["PHONE_NUMBER"] = "PHONE_NUMBER";
    ACTION["DISABLE_CONTINUE_PHONE_NUMBER"] = "DISABLE_CONTINUE_PHONE_NUMBER";
    ACTION["ENABLE_CONTINUE_PHONE_NUMBER"] = "ENABLE_CONTINUE_PHONE_NUMBER";
    ACTION["PRIVACY"] = "PRIVACY";
    ACTION["WHATSAPP_CHECK"] = "WHATSAPP_CHECK";
    ACTION["WHATSAPP_UNCHECK"] = "WHATSAPP_UNCHECK";
    ACTION["GET_OTP"] = "GET_OTP";
    ACTION["GO_TO_PHONE_NUMBER_ACTION"] = "GO_TO_PHONE_NUMBER_ACTION";
    ACTION["RE_SEND_OTP"] = "RE_SEND_OTP";
    ACTION["VERIFY_OTP"] = "VERIFY_OTP";
    ACTION["CHANGE_INPUT"] = "CHANGE_INPUT";
    ACTION["DISABLE_SUBMIT"] = "DISABLE_SUBMIT";
    ACTION["SWITCH_TO_CITY_SELECTION"] = "SWITCH_TO_CITY_SELECTION";
    ACTION["SELECT_CITY"] = "SELECT_CITY";
    ACTION["ADDITIONAL_DETAIL"] = "ADDITIONAL_DETAIL";
    ACTION["GO_TO_HOME"] = "GO_TO_HOME";
    ACTION["GO_TO_FAQ"] = "GO_TO_FAQ";
    ACTION["GO_TO_WHATSAPP"] = "GO_TO_WHATSAPP";
    ACTION["GO_TO_CALL"] = "GO_TO_CALL";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["CITY_GO_BACK"] = "CITY_GO_BACK";
    ACTION["EMAIL_SUCCESS"] = "EMAIL_SUCCESS";
    ACTION["LOGIN_WITH_PASSWORD_ENTRY"] = "LOGIN_WITH_PASSWORD_ENTRY";
    ACTION["GET_PASSWORD"] = "GET_PASSWORD";
    ACTION["LOGIN_WITH_OTP_REDIRECT"] = "LOGIN_WITH_OTP_REDIRECT";
    ACTION["LOGIN_PASSWORD"] = "LOGIN_PASSWORD";
    ACTION["EMPANEL_US"] = "EMPANEL_US";
    ACTION["ARN_CHECK_ACTION"] = "ARN_CHECK_ACTION";
    ACTION["ARN_INPUT_ACTION"] = "ARN_INPUT_ACTION";
    ACTION["ARN_SUBMIT_ACTION"] = "ARN_SUBMIT_ACTION";
    ACTION["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ACTION["T_AND_C"] = "T_AND_C";
})(ACTION || (ACTION = {}));
